import React, { FC, useState, useEffect } from 'react';
import { Swiper } from 'antd-mobile';
import { MTools } from '@/components';
import moment from 'moment';
import { getImgNewsList } from "@/services/service";
import classnames from 'classnames';
import styles from './index.less';

interface ComProps {

}

interface ListItemType {
  id: string;
  cover: string | null | undefined;
  name: string;
  time: string;
  [key: string]: any;
}

const ImgNews: FC<ComProps> = ({

}) => {
  const [imgNewList, setImgNewsList] = useState<ListItemType[]>([]);

  useEffect(() => {
    getList();
  }, []);

  const getList = async () => {
    const _result = await getImgNewsList({});
    if (_result.success) {
      const _list = _result.data || [];
      const _temList = _list.length > 5 ? _list.slice(0, 5) : _list;
      setImgNewsList(_temList);
    } else {
      MTools.Tips('error', '系统异常，请刷新再试');
    }
  }

  const handleNewItemClick = (_item: ListItemType) => {
    MTools.Url.gotoUrl(`/app/newsDetail/${_item.id}?type=imgNews`);
  }

  return (
    <div className={styles.imgNews}>
      <Swiper
        className={classnames(styles.imgNewsSwiper)}
        autoplay
        autoplayInterval={5000}
        loop
      >
        {
          imgNewList.map((item: ListItemType) => (
            <Swiper.Item key={item.id} onClick={() => handleNewItemClick(item)}>
              <div className={styles.imgNewsItem}>
                <div className={styles.sImg}>
                  <img src={item.url || undefined} alt="" />
                </div>
                <div className={styles.sTitW}>
                  <div className={styles.sTitInner}>
                    <div className={styles.sTit}>{item.title}</div>
                    <div className={styles.sTime}>{moment(item.gmtModified).format('YYYY年M月D日')}</div>
                  </div>
                  <div className={styles.sBgLine}></div>
                </div>
              </div>
            </Swiper.Item>
          ))
        }
      </Swiper>
    </div>
  );
};

export default ImgNews;
